import { User } from "../models";

export default {
  get: () => {
    try {
      return localStorage.getItem("token");
    } catch (err) {
      /* eslint-disable */
      console.log("Error ", err);
      /* eslint-enable */
      return false;
    }
  },
  getSPToken: () => {
    try {
      return localStorage.getItem("spToken");
    } catch (err) {
      /* eslint-disable */
      console.log("Error ", err);
      /* eslint-enable */
      return false;
    }
  },
  set: (token: string) => {
    if (token) localStorage.setItem("token", token);
  },
  setSPToken: (token: string) => {
    if (token) localStorage.setItem("spToken", token);
  },
  setUser: (user: User) => {
    if (user) localStorage.setItem("user", JSON.stringify(user));
  },
  getUser: () => {
    const user = localStorage.getItem("user");

    return user ? JSON.parse(user) : null;
  },
  remove: () => {
    localStorage.removeItem("token");
  },
  removeSPToken: () => {
    localStorage.removeItem("spToken");
  },
  removeAll: () => {
    localStorage.clear();
  },
};
